<template>
  <ModalPagePreview v-if="page" :page="page" />
</template>

<script>
import { pageComputed, pageMethods } from '@/store/helper';
import ModalPagePreview from '@/components/Pages/ModalPreview.vue';

export default {
  name: 'PageSingle',
  components: {
    ModalPagePreview,
  },
  props: {
    pageId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...pageComputed,
  },
  created() {
    const { pageId } = this;
    this.setCurrent(pageId);
  },
  methods: {
    ...pageMethods,
  },
};
</script>
